import { render, staticRenderFns } from "./OrderTangjunList.vue?vue&type=template&id=6b2513a8"
import script from "./OrderTangjunList.vue?vue&type=script&lang=js"
export * from "./OrderTangjunList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports